/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import './style.scss';
import { Button, Col, Container, Form, Row, Modal } from 'react-bootstrap';
import { AppContext } from '../../../context/AppContext';
import * as dataInterface from './../../../shared/interfaces';
import { toast } from 'react-toastify';

const Wishlist = () => {
  const { cart, removeFromCart, setQuantity, setCart } = useContext(AppContext);
  const [address, setAddress] = useState<string>('TIRANA');
  const [books, setBooks] = useState<dataInterface.Book[]>([]);
  const [showModal, setShowModal] = useState(false);

  const [guest, setGuest] = useState({
    firstName: '',
    lastName: '',
    city: address,
    email: '',
    phoneNumber: '',
    address: '',
    zipCode: '',
  });

  const findPrice = (book: dataInterface.Book) => {
    if (address === 'PRISHTINA') return book.price_euro;
    if (address === 'SHKUPI') return book.price_denar;
    return book.price_leke;
  };

  const getCurrency = () => {
    if (address === 'PRISHTINA') return '€';
    if (address === 'SHKUPI') return 'Denar';
    return 'Lekë';
  };

  const handleIncrement = (book: dataInterface.Book) => {
    debugger;
    const item = cart.cartItems.find((i: any) => i.product.id === book.id);
    const currentQty = item ? item.quantity : 0;
    setQuantity(book, currentQty + 1);
  };

  const handleDecrement = (book: dataInterface.Book) => {
    const item = cart.cartItems.find((i: any) => i.product.id === book.id);
    if (item && item.quantity > 0) {
      setQuantity(book, item.quantity - 1);
    }
  };

  const getQuantity = (book: dataInterface.Book) => {
    const item = cart.cartItems.find((i: any) => i.product.id === book.id);
    return item ? item.quantity : 0;
  };

  const getTotal = () => {
    return cart.cartItems.reduce((sum: number, item: any) => {
      const price = findPrice(item.product);
      return sum + item.quantity * price;
    }, 0);
  };

  useEffect(() => {
    fetch(`https://strapi-production-a706.up.railway.app/api/books?populate=image&sort[0]=sequence&pagination[limit]=100`)
      .then((res) => res.json())
      .then((data) => setBooks(data.data))
      .catch((err) => console.error('Failed to fetch acitivies:', err));
  }, []);

  const handleOrder = async () => {
    const payload = {
      products: cart.cartItems,
      address,
      guest: {
        ...guest,
        city: address,
      },
    };

    try {
      const res = await fetch('https://strapi-production-a706.up.railway.app/api/order-books', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        toast.success('Porosia u dërgua me sukses');
        setShowModal(false);
        setCart({ cartItems: [] });
      } else {
        const error = await res.text();
        console.error(error);
        toast.error('Dështoi dërgimi i porosisë, ju lutem provoni më vonë');
      }
    } catch (error) {
      toast.info('Gabim në rrjet, ju lutem provoni më vonë!');
    }
  };

  return (
    <div className="section bookspage pagesgrid">
      <Container>
        <Row>
          <Col md={9}>
            <div className="main-title">
              <h3>Botimet tona</h3>
            </div>
            {books?.map((book) => (
              <div key={book.id} className="book-main d-flex">
                <div className="main-left">
                  <img
                    src={book.image.url}
                    alt={book.title}
                  />
                </div>
                <div className="main-right">
                  <h3 className="title">{book.title}</h3>
                  <p className="desc">{book.description}</p>
                </div>
                <div className="main-quantity">
                  <Button onClick={() => handleIncrement(book)}>+</Button>
                  <Button className="nr" disabled>
                    {getQuantity(book)}
                  </Button>
                  <Button onClick={() => handleDecrement(book)}>-</Button>
                </div>
              </div>
            ))}
          </Col>

          <Col md={3}>
            <div className="card-total">
              <div className="card-title">
                <p>Shporta juaj</p>
              </div>
              <div className="books">
                {cart.cartItems?.map((item: any) => (
                  <div className="book" key={item.product.id}>
                    <p className="title">{item.product.title}</p>
                    <p className="quantity">
                      Sasia {item.quantity} x {findPrice(item.product)} ={' '}
                      {item.quantity * findPrice(item.product)}
                    </p>
                    <hr className="white-line" />
                  </div>
                ))}
              </div>

              <hr className="white-line" />
              <div>
                <p>
                  Totali: {getTotal()} {getCurrency()}
                </p>
              </div>

              <div>
                <select
                  className="form-select white-select"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                >
                  <option value="TIRANA">Tiranë</option>
                  <option value="SHKUPI">Shkup</option>
                  <option value="PRISHTINA">Prishtinë</option>
                  <option value="VLORA">Vlorë</option>
                  <option value="DURRESI">Durrës</option>
                </select>
              </div>

              <Button className={'order'} onClick={() => setShowModal(true)}>
                Porositni Tani
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Plotëso të dhënat për porosi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-1 text-start">
              <Form.Label style={{ fontSize: '12px' }}>Emri</Form.Label>
              <Form.Control
                type="text"
                placeholder="Emri"
                value={guest.firstName}
                onChange={(e) => setGuest({ ...guest, firstName: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-1 text-start">
              <Form.Label style={{ fontSize: '12px' }}>Mbiemri</Form.Label>
              <Form.Control
                type="text"
                placeholder="Mbiemri"
                value={guest.lastName}
                onChange={(e) => setGuest({ ...guest, lastName: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-1 text-start">
              <Form.Label style={{ fontSize: '12px' }}>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                value={guest.email}
                onChange={(e) => setGuest({ ...guest, email: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-1 text-start">
              <Form.Label style={{ fontSize: '12px' }}>Numri i telefonit</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nr. i telefonit"
                value={guest.phoneNumber}
                onChange={(e) => setGuest({ ...guest, phoneNumber: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-1 text-start">
              <Form.Label style={{ fontSize: '12px' }}>Adresa</Form.Label>
              <Form.Control
                type="text"
                placeholder="Adresa e plotë"
                value={guest.address}
                onChange={(e) => setGuest({ ...guest, address: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-1 text-start">
              <Form.Label style={{ fontSize: '12px' }}>Kodi postar</Form.Label>
              <Form.Control
                type="text"
                placeholder="Kodi postar"
                value={guest.zipCode}
                onChange={(e) => setGuest({ ...guest, zipCode: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-end">
          <Button variant="secondary" className="m-0" onClick={() => setShowModal(false)}>
            Anulo
          </Button>
          <Button variant="primary" className="ms-2 m-0" onClick={handleOrder}>
            Dërgo Porosinë
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Wishlist;
